(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var cfgEl = document.getElementById('free-gift-config');
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    var THRESHOLD = Math.round(Number(cfg.minimum) * 100);
    var EXCLUDED = cfg.excludedProductIds || [];
    if (!cfg.variantId || !THRESHOLD) return;

    var busy = false;
    var queued = false;
    var debounceTimer = null;

    function money(cents) {
      var v = cents / 100;
      return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
    }

    function giftSubtotal(cart) {
      // Cart subtotal excluding the gift itself, gift cards (they don't
      // count toward the discount prerequisite) and excluded products.
      var subtotal = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id !== cfg.variantId && !i.gift_card && EXCLUDED.indexOf(i.product_id) === -1)
          subtotal += i.final_line_price;
      });
      return subtotal;
    }

    function sync() {
      if (busy) {
        queued = true;
        return;
      }
      busy = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var gift = cart.items.filter(function (i) {
            return i.variant_id === cfg.variantId;
          })[0];
          var subtotal = giftSubtotal(cart);
          updateTeaser(subtotal, cart.item_count);
          if (subtotal >= THRESHOLD && !gift) {
            return mutate('/cart/add.js', { id: cfg.variantId, quantity: 1 });
          }
          if (gift && subtotal < THRESHOLD) {
            return mutate('/cart/change.js', { id: gift.key, quantity: 0 });
          }
          if (gift && gift.quantity > 1) {
            return mutate('/cart/change.js', { id: gift.key, quantity: 1 });
          }
        })
        .catch(function () {})
        .finally(function () {
          busy = false;
          if (queued) {
            queued = false;
            sync();
          }
        });
    }

    function cartPageSectionId() {
      var el = document.getElementById('main-cart-items');
      return el && el.dataset.id ? el.dataset.id : null;
    }

    function mutate(url, body) {
      body.sections = ['minicart-form'];
      var pageSection = cartPageSectionId();
      if (pageSection) body.sections.push(pageSection);
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (state) {
          renderSections(state);
          return refreshCounts();
        });
    }

    function renderSections(state) {
      if (!state.sections) return;
      if (state.sections['minicart-form'] && window.renderMinicartSection) {
        window.renderMinicartSection(state.sections['minicart-form']);
      }
      var pageSection = cartPageSectionId();
      var pageEl = document.getElementById('main-cart-items');
      if (pageEl && pageSection && state.sections[pageSection]) {
        var pageHtml = new DOMParser().parseFromString(state.sections[pageSection], 'text/html');
        var pageInner = pageHtml.querySelector('#main-cart-items');
        if (pageInner) pageEl.innerHTML = pageInner.innerHTML;
      }
      if (window.BlsLazyloadImg) {
        try {
          window.BlsLazyloadImg.init();
        } catch (e) {}
      }
    }

    function refreshCounts() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            if (el.classList.contains('cart-count-drawer')) el.innerHTML = '(' + cart.item_count + ')';
            else el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
          });
          var htp = document.querySelector('header-total-price');
          if (htp && htp.updateTotal) htp.updateTotal(cart);
          document.querySelectorAll('free-ship-progress-bar').forEach(function (bar) {
            if (bar.init) bar.init(cart.items_subtotal_price);
          });
          updateTeaser(giftSubtotal(cart), cart.item_count);
        });
    }

    // Monochrome gift icon in a white circle, mirroring the free-shipping
    // bar's truck icon.
    var GIFT_SVG =
      '<svg width="30" height="30" fill="none" class="absolute">' +
      '<circle cx="15" cy="15" r="14.5" fill="#fff" stroke="currentColor"/>' +
      '<g transform="translate(7.5 7.5) scale(0.625)" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/>' +
      '<line x1="12" y1="22" x2="12" y2="7"/>' +
      '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
      '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></g></svg>';

    function teaserText(subtotal) {
      if (subtotal >= THRESHOLD) return cfg.unlockedText;
      return cfg.lockedText.replace('[amount]', money(THRESHOLD - subtotal));
    }

    // A second threshold bar mirroring the free-shipping one: striped track
    // with the icon riding the fill, message centered underneath. Mounts in
    // the .free-gift-anchor placeholders (drawer); falls back to sitting
    // right after the free-shipping bar (cart page).
    function giftBarHtml() {
      return (
        '<div class="progress-bar cart_bar_w relative rounded-10 pt-10 pb-10">' +
        '<span class="progress percent_shipping_bar transition relative primary-color rounded-10" style="width:0%;">' +
        GIFT_SVG +
        '</span></div>' +
        '<div class="free-gift-progress__message text-center mt-15"></div>'
      );
    }

    function mountPoints() {
      var anchors = [].slice.call(document.querySelectorAll('.free-gift-anchor'));
      if (anchors.length) return anchors.map(function (a) { return { el: a, mode: 'inside' }; });
      return [].slice.call(document.querySelectorAll('free-ship-progress-bar')).map(function (a) {
        return { el: a, mode: 'after' };
      });
    }

    function updateTeaser(subtotal, itemCount) {
      if (!itemCount) {
        document.querySelectorAll('.free-gift-progress').forEach(function (el) {
          el.remove();
        });
        return;
      }
      mountPoints().forEach(function (mount) {
        var bar;
        if (mount.mode === 'inside') {
          bar = mount.el.querySelector('.free-gift-progress');
          if (!bar) {
            bar = document.createElement('div');
            bar.className = 'free-gift-progress block cart_shipping cart_threshold border-bottom px-30 pt-20 pb-20';
            bar.innerHTML = giftBarHtml();
            mount.el.appendChild(bar);
          }
        } else {
          bar = mount.el.nextElementSibling;
          if (!bar || !bar.classList || !bar.classList.contains('free-gift-progress')) {
            bar = document.createElement('div');
            bar.className = 'free-gift-progress block cart_shipping cart_threshold border-bottom px-30 pt-20 pb-20';
            bar.innerHTML = giftBarHtml();
            mount.el.insertAdjacentElement('afterend', bar);
          }
        }
        var text = teaserText(subtotal);
        var msg = bar.querySelector('.free-gift-progress__message');
        if (msg && msg.textContent !== text) msg.textContent = text;
        var pct = Math.min(100, Math.round((subtotal / THRESHOLD) * 100)) + '%';
        var fill = bar.querySelector('.progress');
        if (fill && fill.style.width !== pct) fill.style.width = pct;
      });
    }

    // Re-check after every cart mutation. The theme's various flows (drawer
    // qty buttons, cart page, quick add, upsells) all POST to /cart/* via
    // fetch, and some of them replace the drawer's DOM nodes wholesale — so
    // a MutationObserver on a section element dies after the first render.
    // Hooking fetch catches every path reliably.
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var result = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        result
          .then(function () {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(sync, 400);
          })
          .catch(function () {});
      }
      return result;
    };

    // Skip the initial cart fetch for empty carts (most visitors) — the
    // header badge already tells us the count, and the fetch hook covers
    // the first add-to-cart.
    var countEl = document.querySelector('.cart-count');
    var initialCount = countEl ? parseInt((countEl.textContent || '').replace(/\D/g, ''), 10) : NaN;
    if (initialCount !== 0) sync();
  });
})();
